import * as React from "react";
import "./CaregiverLandingScreen.css";
import { Link } from "react-router-dom";

export class CaregiverLandingScreen extends React.Component<{agencyName: string}, {}> {
    constructor(props: {agencyName: string}) {
        super(props);
    }
    render() {
        return (
            <div className={"CaregiverLandingPage__root"}>
                <h1 className={"CaregiverLandingPage__agencyHeader"}>Welcome to {this.props.agencyName} HR!</h1>
                <h4 className={"text-secondary mb-0"}>The fast and easy way to find cases!</h4>
                <Link to={"/caregiverPhone"}>
                    <button className="CaregiverLandingPage__submit btn btn-primary btn-xl">Lets start!</button>
                </Link>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CaregiverLandingScreen.tsx